module.exports = __webpack_public_path__ + "img/area-comum-10.be6973f1.png";